import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, Ticket } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function EventTicket() {
  const [params] = useSearchParams();
  const ticketId = params.get("ticket_id");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [code, setCode] = useState("");
  const tries = useRef(0);

  useEffect(() => {
    if (!ticketId) { setStatus("failed"); return; }
    const poll = async () => {
      try {
        const { data } = await api.post("/events/tickets/confirm", { ticket_id: ticketId, session_id: sessionId });
        if (data.status === "paid") { setStatus("paid"); setCode(data.code); return; }
      } catch (e) { /* retry */ }
      tries.current += 1;
      if (tries.current < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [ticketId, sessionId]);

  return (
    <div data-testid="event-ticket-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-primary mx-auto animate-spin" />
            <h1 className="font-display text-3xl mt-6">Confirming your tickets</h1>
          </>
        )}
        {status === "paid" && (
          <>
            <Ticket data-testid="ticket-confirmed-icon" className="w-12 h-12 text-emerald-500 mx-auto" />
            <h1 className="font-display text-3xl mt-6">You're on the list</h1>
            <div className="mt-6 rounded-2xl border border-primary/40 bg-primary/5 px-8 py-6 inline-block">
              <p className="text-xs tracking-[0.2em] uppercase text-muted-foreground">Ticket code</p>
              <p className="font-outfit font-semibold text-3xl mt-1 tracking-widest" data-testid="ticket-code">{code}</p>
            </div>
            <p className="text-muted-foreground mt-4 text-sm">Show this code at the door. A confirmation email is on its way.</p>
          </>
        )}
        {(status === "pending" || status === "failed") && (
          <>
            <XCircle className="w-12 h-12 text-amber-400 mx-auto" />
            <h1 className="font-display text-3xl mt-6">Payment not confirmed</h1>
            <p className="text-muted-foreground mt-3 text-sm">If you paid, your tickets will confirm shortly.</p>
          </>
        )}
        <Link to="/restaurants"><Button variant="outline" className="mt-8 rounded-full">Back to restaurants</Button></Link>
      </div>
    </div>
  );
}
